import "./_asset-name-with-logo.scss";

import classNames from "classnames";

import AssetLogo from "../../logo/AssetLogo";
import {AssetListItemData} from "../../util/assetModels";
import AssetName from "../AssetName";

interface AssetNameWithLogoProps {
  asset: Pick<AssetListItemData, "name" | "unit_name" | "id" | "clawback_address">;
  customClassName?: string;
  nameCharLimit?: number;
}

function AssetNameWithLogo({
  asset,
  customClassName,
  nameCharLimit
}: AssetNameWithLogoProps) {
  return (
    <div
      className={classNames(
        "is-vertically-centered",
        "asset-name-with-logo",
        customClassName
      )}>
      <AssetLogo asset={asset} />

      <AssetName asset={asset} charLimit={nameCharLimit} />
    </div>
  );
}

export default AssetNameWithLogo;
